import { AbstractFormArgument, AbstractSearchArgument } from './global'
import { CONDITION_TYPE, DATE_PICKER_SHOW_TYPE } from '@/utils/constants'

const PROVINCE_CONDITION = [
  {
    name: 'date',
    title: '日期',
    type: CONDITION_TYPE.DATE,
    value: '',
    visible: true,
    config: {
      type: DATE_PICKER_SHOW_TYPE.DATE_RANGE,
      format: 'yyyy-MM-dd',
      valueFormat: 'yyyy-MM-dd'
    }
  },
  {
    name: 'top',
    title: '排名',
    placeholder: '--请选择排名--',
    type: CONDITION_TYPE.SELECT,
    value: '前10',
    visible: true,
    config: {
      list: [
        {value: 5, label: '前5'},
        {value: 10, label: '前10'},
        {value: 15, label: '前15'},
        {value: 20, label: '前20'}
      ]
    }
  },
  {
    name: 'itemTitle',
    title: '项目',
    placeholder: '--请选择项目--',
    type: CONDITION_TYPE.SELECT,
    value: '',
    visible: true,
    config: {
      list: []
    }
  }
]

class SearchArgument extends AbstractSearchArgument {
  constructor () {
    super()
    this.startTime = ''
    this.endTime = ''
    this.top = ''
    this.itemTitle = ''
    this.customerTitle = ''
    this.regulator = ''
    this.channelTitle = ''
    this.accountTitle = ''
    this.status = ''
    this.modeType = ''
  }
}

class FormArgument extends AbstractFormArgument {
  constructor () {
    super()

    this.itemSolutionId = null
    this.content = null
    this.replyContent = null
  }
}

export {
  PROVINCE_CONDITION,
  SearchArgument,
  FormArgument
}



// WEBPACK FOOTER //
// ./src/models/region-pie.js